module.exports = __webpack_public_path__ + "static/img/icon3.8de0ac3.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/fxcp_result/images/icon3.png
// module id = 9dRf
// module chunks = 21